import{jsx as e}from"react/jsx-runtime";import{Fonts as o}from"@vds-core/typography";import{calculateRem as r}from"@vds-core/utilities";import{ColorTokens as t}from"@vds-tokens/color";import{TypographyTokens as n}from"@vds-tokens/typography";import i,{css as a}from"styled-components";const l=i.div.withConfig({displayName:"StyledBadge",componentId:"VDS__sc-ttpaf5-0"})`
  display: inline-block;
  text-overflow: ellipsis;
  background-color: ${function({$fillColor:e}){return e}};
  color: ${function({$textColor:e}){return e}};
  border-radius: 2px;
  font-family: ${o.VerizonNHGeTX};
  font-size: ${r(n.fontsize.body[12].value)};
  font-weight: ${n.fontweight.bold.value};
  line-height: ${r(n.lineheight.body[16].value)};
  width: auto;
  height: auto;
  min-width: 23px;
  max-width: ${function({$maxWidth:e}){return e}};
  padding: 2px 4px;
  box-sizing: border-box;
`,d=i.div.withConfig({displayName:"StyledWrapper",componentId:"VDS__sc-ttpaf5-1"})`
  margin: 0;
  ${function({$maxWidth:e,$numberOfLines:o}){return e&&o&&a`
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: ${o};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}}
`,u=function(o){const{fillColor:r,surface:n,children:i,numberOfLines:a,maxWidth:u,id:s}=o;return e(l,{$fillColor:function(){switch(r){case"red":default:return t.badges.background.red[`on${n}`].value;case"yellow":return t.badges.background.yellow[`on${n}`].value;case"green":return t.badges.background.green[`on${n}`].value;case"orange":return t.badges.background.orange[`on${n}`].value;case"blue":return t.badges.background.blue[`on${n}`].value;case"black":return t.badges.background.black[`on${n}`].value;case"white":return t.badges.background.white[`on${n}`].value}}(),$textColor:"red"===r||"black"===r?t.palette.white.value:"yellow"===r||"white"===r?t.palette.black.value:"green"===r||"orange"===r||"blue"===r?t.elements.primary.inverse[`on${n}`].value:t.elements.primary.ondark.value,$maxWidth:u,id:s,children:e(d,{$numberOfLines:a,$maxWidth:u,children:i})})};u.defaultProps={fillColor:"red",surface:"light"};export{u as default};
